import React from 'react';
import { HotkeysMap } from 'owa-hotkeys-map';
import { observer } from 'mobx-react-lite';
import getTimeStreamHotkeyCategories from './getTimeStreamHotkeyCategories';
import getTimeStreamHotkeyCommands from './getTimeStreamHotkeyCommands';

export default observer(function TimeStreamHotkeysMap() {
    return (
        <HotkeysMap
            firstColumnLength={3}
            commandCategories={getTimeStreamHotkeyCategories()}
            hotkeyCommands={getTimeStreamHotkeyCommands()}
        />
    );
});
